var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4936 2.71235C11.7002 2.2938 12.297 2.2938 12.5036 2.71235L15.1776 8.13047C15.2596 8.29668 15.4182 8.41188 15.6016 8.43853L21.5809 9.30736C22.0427 9.37448 22.2272 9.9421 21.8929 10.2679L17.5663 14.4853C17.4336 14.6147 17.373 14.8011 17.4044 14.9838L18.4257 20.9389C18.5046 21.3989 18.0218 21.7497 17.6087 21.5325L12.2607 18.7209C12.0966 18.6346 11.9006 18.6346 11.7366 18.7209L6.38855 21.5325C5.97542 21.7497 5.49257 21.3989 5.57147 20.9389L6.59285 14.9838C6.62419 14.8011 6.56362 14.6147 6.4309 14.4853L2.10427 10.2679C1.77004 9.9421 1.95447 9.37448 2.41636 9.30736L8.39562 8.43853C8.57904 8.41188 8.7376 8.29668 8.81962 8.13047L11.4936 2.71235Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandFilter);
export default __webpack_public_path__ + "static/media/brand-filter.8c1a1b5b6b7bff430d41d7870fe98178.svg";
export { ForwardRef as ReactComponent };